import { useCallback } from "react";
import { uploadFileAction } from "../../../Files/redux/actions";
import { generateId } from "../../../../shared/utils/generateId";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { TFileTransferInfo } from "../types";
import { createNotification } from "../../../../app/state/notificationSlice/slice";

export const useFileTransferModal = (info: TFileTransferInfo | null) => {
  const dispatch = useAppDispatch();

  const handleClick = useCallback(
    async (type: "download" | "set_to_artifact") => {
      if (!info) return;

      try {
        let blob: Blob;
        let fileName = info.name || "file.txt";

        if ("content" in info && typeof info.content === "string") {
          blob = new Blob([info.content], {
            type: "text/markdown;charset=utf-8",
          });
        } else if (info.url) {
          const response = await fetch(info.url);
          if (!response.ok) throw new Error("Network response was not ok");
          blob = await response.blob();
        } else {
          throw new Error("Neither url nor content provided in info");
        }

        if (type === "download") {
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
        } else if (type === "set_to_artifact") {
          const file = new File([blob], fileName, { type: blob.type });
          const postObj = {
            id: generateId(),
            file_name: fileName,
            file: file,
          };
          dispatch(uploadFileAction({ data: [postObj], targetObjectId: null }))
            .unwrap()
            .then(() =>
              dispatch(
                createNotification(
                  "success",
                  "Файл добавлен в Артефакты",
                  3000,
                ),
              ),
            );
        }
      } catch (err) {
        console.error("Failed to handle file:", err);
        if (info.url) {
          window.open(info.url, "_blank");
        }
      }
    },
    [info],
  );

  return {
    handleClick,
  };
};
